export default __webpack_public_path__ + "static/media/card3.a801775a.wav";